import { render, staticRenderFns } from "./LeaveReport.vue?vue&type=template&id=32f9977c&scoped=true&"
import script from "./LeaveReport.vue?vue&type=script&lang=js&"
export * from "./LeaveReport.vue?vue&type=script&lang=js&"
import style0 from "./LeaveReport.vue?vue&type=style&index=0&id=32f9977c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f9977c",
  null
  
)

export default component.exports